import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { AppComponent } from '../app.component';
import { ApiService } from '../services/api.service';
import { saveAs } from 'file-saver';
import { ThrowStmt } from '@angular/compiler';
import { PermissionsService } from '../services/permissions.service';
import { SortListService } from '../services/sort-list.service';

@Component({
  selector: 'app-late-reg-visitors-details',
  templateUrl: './late-reg-visitors-details.component.html',
  styleUrls: ['./late-reg-visitors-details.component.scss']
})
export class LateRegVisitorsDetailsComponent implements OnInit {

  public payment_report: any;
  public visitors_detail: any;
  public from_date = moment(new Date()).format('YYYY-MM-DD');
  public to_date = moment(new Date()).format('YYYY-MM-DD');
  public payment_status = 'Pending';
  public onChangeSearch = new Subject<string>();
  public perPage = 20;
  public totalCount = 0;
  public page = 1;
  public allDarshanTypes = [];
  public darshan_type_id = '';
  public maxDate =  ''; //moment(new Date()).format('YYYY-MM-DD');
  public department_id = '';
  public allDepartments = [];




  constructor(
    private apiService: ApiService,
    private appComponet: AppComponent,
    public permissionsService: PermissionsService,
    private sortListService: SortListService
    
    ) { }

  ngOnInit() {
    this.getList('');
    this.getAllDarshanTypes();
    this.getAllDepartment();

  }

  getList(_type) {
    this.appComponet.showLoader();
    const from_date = moment(this.from_date).format('YYYY-MM-DD');
    const to_date = moment(this.to_date).format('YYYY-MM-DD');
    this.apiService.getDataFromServer(`/late_reg_visitors_details?date=${from_date}&end_date=${to_date}&page=${this.page}&perpage=${this.perPage}&darshan_type_id=${this.darshan_type_id}&department_id=${this.department_id}`).subscribe(
      (res: any) => {
        this.appComponet.hideLoader();
        this.visitors_detail = res;
        this.visitors_detail.data.map(res => {
          res.date = moment.utc(res.registration.date_of_visit).local().format('DD-MM-YYYY');
          res.regDateTime = moment.utc(res.registration.created_at).local().format('DD-MM-yyyy HH:mm:ss');
        });
        this.totalCount = res.total;
      },
      err => {
        this.appComponet.hideLoader();
        console.log(err);
      }
    );
  }


  getAllDarshanTypes() {
    this.apiService.getDataFromServer('/darshan_types').subscribe(
      res => {
        // this.allDarshanTypes = res['data'];
        this.sortListService.sortList(res['data'],'name').then(res => {
          this.allDarshanTypes = res;
        });
      },
      err => {
        console.log(err);
      }
    );
  }

  getAllDepartment() {
    this.apiService.getDataFromServer('/departments').subscribe(
      res => {
        // this.allDepartments = res['data'];
        this.sortListService.sortList(res['data'],'name').then(res => {
          this.allDepartments = res;
        });
      },
      err => {
        console.log(err);
      }
    );
  }


  public export() {
    const from_date = moment(this.from_date).format('YYYY-MM-DD');
    const to_date = moment(this.to_date).format('YYYY-MM-DD');
    this.appComponet.showLoader();
    this.apiService.getDataFromServer(`/export_late_registrations_visitors_detail?date=${from_date}&end_date=${to_date}&page=${this.page}&perpage=10000&darshan_type_id=${this.darshan_type_id}&department_id=${this.department_id}`).subscribe((res: any) => {
      if(res.status_code === 200) {
        const fileArry =  res.data.split('/uploads/');
        this.apiService.getBlobFileFromServer(res.data).subscribe(res => {
          this.appComponet.hideLoader();
          let blob:any = new Blob([res], { type: res.type });
          const url = window.URL.createObjectURL(blob);
          let file_name = fileArry[fileArry.length - 1];
          saveAs(blob, file_name);
        }, (error) => {
        });
      } 
      this.appComponet.hideLoader();
    }, (error) => {
      this.appComponet.hideLoader();
      console.log('error' , error);
    });
  }


}